import { Container } from '@mui/material';

import './landing.css';
import Products from '../layouts/Content/Products'
import Company from '../layouts/Content/Company'
import Families from '../layouts/Content/Families'
import Inspiration from '../layouts/Content/Inspiration';

function Landing({ refs }) {
  return (
    <Container maxWidth="xl" className="landing-container" disableGutters sx={{ overflow: 'hidden' }}>
      <div ref={refs.products}>
        <Products />
      </div>
      <div ref={refs.company}>
        <Company />
      </div>
      <Families />
      <div ref={refs.inspiration}>
        <Inspiration />
      </div>
    </Container>
  );
}

export default Landing;